import React from 'react';
import { SoftwaresSkillsCard, SoftwaresSkillsSection } from '../styled/SoftwaresSkills.styled';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';
import { useTheme } from 'styled-components';
import { skillData } from '../../data';

const SoftwaresSkills = () => {
    const theme = useTheme();
    return (
        <SoftwaresSkillsSection>
            <h4>Softwares Skills</h4>
                <SoftwaresSkillsCard>
                    <ResponsiveContainer width="100%" height="100%" >
                        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={skillData} >
                            <PolarGrid stroke={theme.color.first} />
                            <PolarAngleAxis dataKey="subject" transform={`scale(1)`} stroke={theme.color.first} />
                            {/* <PolarRadiusAxis domain={[0, 100]} /> */}
                            <Radar name="Mike" dataKey="A" stroke={theme.color.first} fill={theme.color.second} fillOpacity={0.6} />
                        </RadarChart>
                    </ResponsiveContainer>
                </SoftwaresSkillsCard>
        </SoftwaresSkillsSection>
    );
};

export default SoftwaresSkills;